<lib-list-page
    [host]="this"
    title="Task Catalog"
    icon="auto_awesome_mosaic"
    searchPlaceholder="Search by task type, name, description, tag, category…"
    [activeChips]="activeFilterChips()"
    (chipRemove)="removeFilterChip($event)"
    totalIcon="auto_awesome_mosaic"
    totalLabel="Tasks"
    emptyStateIcon="auto_awesome_mosaic"
    emptyStateTitle="No tasks registered"
    emptyStateSubtitle="When a runner JVM boots its @TaskDefinition methods publish on tasksense.task.definition and appear here. If you expect tasks, check that at least one runner is up.">

  <ng-container actions>
    <button mat-icon-button (click)="refreshData(true)" matTooltip="Refresh" aria-label="Refresh">
      <mat-icon>refresh</mat-icon>
    </button>
  </ng-container>

  <ng-container filters>
    <div class="filter-select-box">
      <div class="filter-context-label">
        <mat-icon class="filter-context-icon">category</mat-icon> Tags
        <span class="filter-active-count" *ngIf="filter().tags?.length as count">{{ count }}</span>
      </div>
      <lib-filter-autocomplete
        #capabilityFilter
        [source]="capabilityList()"
        [filterSignal]="filter"
        field="tags"
        chipIcon="category"
        label="Tags" />
    </div>
  </ng-container>

  <table mat-table table [dataSource]="dataSource()" class="full-width-table" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="taskType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="taskType" class="nowrap">Task Type</th>
      <td mat-cell *matCellDef="let t" class="nowrap">
        <div class="task-type-line">
          <strong class="task-type-mono">{{ t.taskType }}</strong>
          <span class="task-version">{{ t.definitionVersion }}</span>
        </div>
        <div class="cell-sub" *ngIf="requirementSummary(t) as r">{{ r }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</th>
      <td mat-cell *matCellDef="let t">
        <div><strong>{{ t.name || '—' }}</strong></div>
        <div class="cell-sub" *ngIf="t.description as d" [matTooltip]="d">{{ d }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="capabilities">
      <th mat-header-cell *matHeaderCellDef>Tags</th>
      <td mat-cell *matCellDef="let t">
        <mat-chip-set>
          <mat-chip *ngFor="let c of t.tags" class="capability-chip">{{ c }}</mat-chip>
        </mat-chip-set>
      </td>
    </ng-container>

    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="uiHints.category" class="nowrap">Category</th>
      <td mat-cell *matCellDef="let t" class="nowrap">{{ category(t) }}</td>
    </ng-container>

    <ng-container matColumnDef="lastRegisteredAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="lastRegisteredAt" class="nowrap">Last Registered</th>
      <td mat-cell *matCellDef="let t" class="nowrap">
        {{ t.lastRegisteredAt | date:'medium' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="star" stickyEnd>
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let t" class="nowrap row-actions">
        <button mat-icon-button (click)="onScheduleTask(t)"
                *ngIf="permissionChecker.hasAccessToViewSchedulingSchedules()"
                matTooltip="Schedule this task" aria-label="Schedule this task">
          <mat-icon>add_alarm</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="selectable-table-row"></tr>
  </table>

</lib-list-page>
